import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { getProfitLossAura } from "../../src/Server/api";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router';

function Profitlossaura() {
    const [activeTab, setActiveTab] = useState('Casino');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [reportData, setReportData] = useState([]);
    const [totals, setTotals] = useState(null);

    const [pagination, setPagination] = useState({
        current_page: 1,
        per_page: 50,
        total_records: 0,
        total_pages: 1
    });

    const [periodFrom, setPeriodFrom] = useState({
        date: '',
        time: ''
    });

    const [periodTo, setPeriodTo] = useState({
        date: '',
        time: ''
    });

    const [selectedLast, setSelectedLast] = useState("all");
    const [selectedUser, setSelectedUser] = useState(null);
    const [expandedRows, setExpandedRows] = useState({});

    const userOptions = [
        { value: 'no options', label: 'no options' },
    ];

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '38px',
            borderRadius: '4px',
            border: '1px solid #ced4da',
            boxShadow: state.isFocused
                ? '0 0 0 0.2rem rgba(13,110,253,0.25)'
                : null,
            '&:hover': {
                borderColor: '#86b7fe'
            }
        }),

        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? '#0d6efd'
                : state.isFocused
                    ? '#e9ecef'
                    : null,
            color: state.isSelected ? 'white' : '#212529',
            cursor: 'pointer'
        }),

        menu: (provided) => ({
            ...provided,
            zIndex: 9999
        })
    };

    // =========================
    // GET GROUP BY
    // =========================
    const getGroupBy = () => {
        switch (activeTab) {
            case 'Casino':
                return 'agent';

            case 'CasinoGamePnL':
                return 'game';

            case 'PlayerPnL':
                return 'user';

            default:
                return 'agent';
        }
    };

    // =========================
    // GET ADMIN ID
    // =========================
    const getAdminId = () => {
        return localStorage.getItem("admin_id");
    };

    // =========================
    // BUILD PAYLOAD
    // =========================
    const buildBasePayload = (additionalParams = {}) => {
        const admin_id = getAdminId();

        return {
            from_date: periodFrom.date,
            to_date: periodTo.date,

            group_by: getGroupBy(),

            agent_id: admin_id,

            last:
                selectedLast === "all"
                    ? undefined
                    : parseInt(selectedLast),

            user_id: selectedUser?.value || undefined,

            page: pagination.current_page || 1,

            per_page: pagination.per_page || 50,

            ...additionalParams
        };
    };

    // =========================
    // FETCH REPORT DATA
    // =========================
    const fetchReportData = async (customPayload = null) => {
        setLoading(true);
        setError(null);

        try {
            let payload;

            if (customPayload) {
                payload = {
                    ...customPayload,
                    agent_id:
                        customPayload.agent_id || getAdminId()
                };
            } else {
                payload = buildBasePayload();
            }

            console.log("📤 Sending payload:", payload);

            const response = await getProfitLossAura(payload);

            console.log("📥 Full API Response:", response);

            if (!response) {
                throw new Error(
                    "No response received from server"
                );
            }

            if (
                response.status === 200 ||
                response.status === 1
            ) {
                const actualData =
                    response.data?.data || [];

                setReportData(actualData);

                // =========================
                // TOTALS
                // =========================
                if (response.data?.total) {
                    setTotals(response.data.total);
                } else {
                    setTotals(null);
                }

                // =========================
                // PAGINATION
                // =========================
                if (response.data?.pagination) {
                    setPagination({
                        current_page:
                            response.data.pagination.current_page || 1,

                        per_page:
                            response.data.pagination.per_page || 50,

                        total_records:
                            response.data.pagination.total_records || 0,

                        total_pages:
                            response.data.pagination.total_pages || 1
                    });
                }

                console.log(
                    "✅ Data set:",
                    actualData
                );
            } else {
                setError(
                    response.message ||
                    "Failed to fetch data"
                );

                setReportData([]);
                setTotals(null);

                setPagination({
                    current_page: 1,
                    per_page: 50,
                    total_records: 0,
                    total_pages: 1
                });
            }
        } catch (err) {
            console.error("Error:", err);

            setError(
                err.message ||
                "Failed to fetch data. Please try again."
            );

            setReportData([]);
            setTotals(null);

            setPagination({
                current_page: 1,
                per_page: 50,
                total_records: 0,
                total_pages: 1
            });
        } finally {
            setLoading(false);
        }
    };

    // =========================
    // INITIAL / TAB FETCH
    // =========================
    useEffect(() => {
        fetchReportData();
    }, [activeTab]);

    // =========================
    // TAB CHANGE
    // =========================
    const handleTabChange = (tab) => {
        setActiveTab(tab);

        setExpandedRows({});

        setPagination({
            current_page: 1,
            per_page: 50,
            total_records: 0,
            total_pages: 1
        });
    };

    // =========================
    // DATE / TIME
    // =========================
    const handlePeriodFromDateChange = (e) => {
        setPeriodFrom({
            ...periodFrom,
            date: e.target.value
        });
    };

    const handlePeriodFromTimeChange = (e) => {
        setPeriodFrom({
            ...periodFrom,
            time: e.target.value
        });
    };

    const handlePeriodToDateChange = (e) => {
        setPeriodTo({
            ...periodTo,
            date: e.target.value
        });
    };

    const handlePeriodToTimeChange = (e) => {
        setPeriodTo({
            ...periodTo,
            time: e.target.value
        });
    };

    // =========================
    // LAST CHANGE
    // =========================
    const handleLastChange = (e) => {
        setSelectedLast(e.target.value);
    };

    // =========================
    // USER CHANGE
    // =========================
    const handleUserChange = (selectedOption) => {
        setSelectedUser(selectedOption);
    };

    // =========================
    // SEARCH
    // =========================
    const handleSearch = () => {
        const payload = buildBasePayload({
            page: 1
        });

        setPagination(prev => ({
            ...prev,
            current_page: 1
        }));

        fetchReportData(payload);
    };

    // =========================
    // PAGE CHANGE
    // =========================
    const handlePageChange = (page) => {
        if (
            page < 1 ||
            page > pagination?.total_pages
        ) {
            return;
        }

        const payload = buildBasePayload({
            page: page,
            per_page: pagination?.per_page || 50
        });

        setPagination(prev => ({
            ...prev,
            current_page: page
        }));

        fetchReportData(payload);
    };

    // =========================
    // TODAY
    // =========================
    const handleJustForToday = () => {
        const today = new Date();

        const todayStr =
            today.toISOString().split('T')[0];

        const payload = buildBasePayload({
            from_date: todayStr,
            to_date: todayStr,
            page: 1
        });

        setPagination(prev => ({
            ...prev,
            current_page: 1
        }));

        fetchReportData(payload);
    };

    // =========================
    // YESTERDAY
    // =========================
    const handleFromYesterday = () => {
        const yesterday = new Date();

        yesterday.setDate(
            yesterday.getDate() - 1
        );

        const yesterdayStr =
            yesterday.toISOString().split('T')[0];

        const payload = buildBasePayload({
            from_date: yesterdayStr,
            to_date: yesterdayStr,
            page: 1
        });

        setPagination(prev => ({
            ...prev,
            current_page: 1
        }));

        fetchReportData(payload);
    };

    // =========================
    // GET P/L
    // =========================
    const handleGetPL = () => {
        const payload = buildBasePayload({
            page: 1
        });

        setPagination(prev => ({
            ...prev,
            current_page: 1
        }));

        fetchReportData(payload);
    };

    // =========================
    // EXPAND / COLLAPSE
    // =========================
    const toggleExpand = (id) => {
        setExpandedRows(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    // =========================
    // FORMAT NUMBER
    // =========================
    const formatNumber = (num) => {
        if (
            num === undefined ||
            num === null ||
            num === ''
        ) {
            return '0.00';
        }

        const number = Number(num);

        if (number < 0) {
            return `(${Math.abs(number)
                .toFixed(2)
                .replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ','
                )})`;
        }

        return number
            .toFixed(2)
            .replace(
                /\B(?=(\d{3})+(?!\d))/g,
                ','
            );
    };

    // =========================
    // COLOR
    // =========================
    const getColorClass = (num) => {
        if (
            num === undefined ||
            num === null
        ) {
            return '';
        }

        return Number(num) < 0
            ? 'text-danger'
            : 'text-success';
    };

    // =========================
    // FILTER FORM
    // =========================
    const renderFilterForm = () => (
        <form
            className="bet_status bet-list-live"
            onSubmit={(e) =>
                e.preventDefault()
            }
        >
            <div className="bet_outer">

                {/* PERIOD FROM */}
                <div className="mb-lg-0 mb-3 col-lg-3 col-sm-3">
                    <div className="bet-sec bet-period">

                        <label
                            className="me-2 form-label"
                            style={{ fontWeight: 600 }}
                        >
                            Period From
                        </label>

                        <div className="form-group">

                            <input
                                type="date"
                                className="form-control"
                                value={periodFrom.date}
                                onChange={
                                    handlePeriodFromDateChange
                                }
                            />

                            <input
                                placeholder="00:00"
                                type="time"
                                className="small_form_control form-control"
                                value={periodFrom.time}
                                onChange={
                                    handlePeriodFromTimeChange
                                }
                                style={{ width: 80 }}
                            />

                        </div>
                    </div>
                </div>

                {/* PERIOD TO */}
                <div className="mb-lg-0 mb-3 col-lg-3 col-sm-3">
                    <div className="bet-sec bet-period">

                        <label
                            className="me-2 form-label"
                            style={{ fontWeight: 600 }}
                        >
                            Period To
                        </label>

                        <div className="form-group">

                            <input
                                type="date"
                                className="form-control"
                                value={periodTo.date}
                                onChange={
                                    handlePeriodToDateChange
                                }
                            />

                            <input
                                placeholder="00:00"
                                type="time"
                                className="small_form_control form-control"
                                value={periodTo.time}
                                onChange={
                                    handlePeriodToTimeChange
                                }
                                style={{ width: 80 }}
                            />

                        </div>
                    </div>
                </div>

                {/* LAST */}
                <div className="bet-sec bet-period">

                    <label
                        className="form-label"
                        style={{ fontWeight: 600 }}
                    >
                        Last
                    </label>

                    <select
                        aria-label="Default select example"
                        className="small_select form-select"
                        value={selectedLast}
                        onChange={
                            handleLastChange
                        }
                    >
                        <option value="all">
                            All
                        </option>

                        <option value="25">
                            25 Txn
                        </option>

                        <option value="50">
                            50 Txn
                        </option>

                        <option value="100">
                            100 Txn
                        </option>

                        <option value="200">
                            200 Txn
                        </option>
                    </select>

                </div>

                {/* USER LIST */}
                <div className="mb-lg-0 mb-3 col-lg-3 col-sm-3">

                    <div className="d-flex align-items-center">

                        <label
                            className="form-label"
                            style={{
                                fontWeight: 600,
                                marginRight: 5
                            }}
                        >
                            User List
                        </label>

                        <div
                            style={{
                                minWidth: '200px'
                            }}
                        >
                            <Select
                                value={selectedUser}
                                onChange={
                                    handleUserChange
                                }
                                options={userOptions}
                                styles={customStyles}
                                placeholder="Select User"
                                isClearable
                                isSearchable
                                className="basic-single"
                                classNamePrefix="select"
                            />
                        </div>

                        <button
                            type="button"
                            className="btn btn-primary ms-2"
                            onClick={handleSearch}
                            style={{
                                padding: '6px 15px',
                                borderRadius: '4px',
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                            disabled={loading}
                        >
                            {loading
                                ? 'Loading...'
                                : 'Search'}
                        </button>

                    </div>
                </div>

            </div>

            {/* HISTORY BUTTONS */}
            <div className="history-btn mt-3">

                <ul className="list-unstyled mb-0">

                    <li>
                        <button
                            type="button"
                            className="me-0 theme_light_btn btn btn-primary"
                            onClick={
                                handleJustForToday
                            }
                        >
                            Just For Today
                        </button>
                    </li>

                    <li>
                        <button
                            type="button"
                            className="me-0 theme_light_btn btn btn-primary"
                            onClick={
                                handleFromYesterday
                            }
                        >
                            From Yesterday
                        </button>
                    </li>

                    <li>
                        <button
                            type="button"
                            className="theme_light_btn theme_dark_btn btn btn-primary"
                            onClick={handleGetPL}
                            disabled={loading}
                        >
                            {loading
                                ? 'Loading...'
                                : 'Get P/L'}
                        </button>
                    </li>

                </ul>

            </div>
        </form>
    );

    // =========================================================
    // CASINO TABLE
    // ONLY UID + UPLINE P/L
    // =========================================================
    const renderCasinoTable = () => (
        <div className="account-table">

            <div className="responsive">

                {loading ? (
                    <div className="text-center py-4">
                        Loading...
                    </div>
                ) : error ? (
                    <div className="alert alert-danger">
                        {error}
                    </div>
                ) : (
                    <>
                        <table className="table">

                            <thead>
                                <tr>
                                    <th scope="col">
                                        UID
                                    </th>

                                    <th scope="col">
                                        Upline P/L
                                    </th>
                                </tr>
                            </thead>

                            <tbody>

                                {reportData &&
                                reportData.length > 0 ? (
                                    <>
                                        {reportData.map(
                                            (item) => {
                                                const rowId =
                                                    item.uid ||
                                                    item.id;

                                                return (
                                                    <React.Fragment
                                                        key={rowId}
                                                    >

                                                        <tr
                                                            id={rowId}
                                                        >

                                                            {/* UID */}
                                                            <td className="text-start">

                                                                {item.children &&
                                                                    item.children.length >
                                                                    0 && (
                                                                        <i
                                                                            id={`icon_${rowId}`}
                                                                            className={`fas fa-${
                                                                                expandedRows[
                                                                                    rowId
                                                                                ]
                                                                                    ? 'minus'
                                                                                    : 'plus'
                                                                            }-square pe-2`}
                                                                            onClick={() =>
                                                                                toggleExpand(
                                                                                    rowId
                                                                                )
                                                                            }
                                                                            style={{
                                                                                cursor:
                                                                                    'pointer'
                                                                            }}
                                                                        />
                                                                    )}

                                                                <a
                                                                    href="#"
                                                                    className="text-primary"
                                                                    onClick={(
                                                                        e
                                                                    ) =>
                                                                        e.preventDefault()
                                                                    }
                                                                >
                                                                    <span>
                                                                        AG
                                                                    </span>
                                                                </a>

                                                                {item.name ||
                                                                    item.uid ||
                                                                    ''}
                                                            </td>

                                                            {/* UPLINE P/L */}
                                                            <td>
                                                                <span
                                                                    className={getColorClass(
                                                                        item.upline_pl
                                                                    )}
                                                                >
                                                                    {formatNumber(
                                                                        item.upline_pl
                                                                    )}
                                                                </span>
                                                            </td>

                                                        </tr>

                                                        {/* CHILDREN */}
                                                        {item.children &&
                                                            item.children.length >
                                                            0 &&
                                                            expandedRows[
                                                                rowId
                                                            ] && (
                                                                <tr className="expand">

                                                                    <td
                                                                        colSpan={
                                                                            2
                                                                        }
                                                                        className="expand_wrap"
                                                                        style={{
                                                                            background:
                                                                                'lightgrey'
                                                                        }}
                                                                    >

                                                                        <table
                                                                            style={{
                                                                                width:
                                                                                    '100%',
                                                                                background:
                                                                                    'lightgrey'
                                                                            }}
                                                                        >

                                                                            <tbody
                                                                                style={{
                                                                                    background:
                                                                                        'lightgrey'
                                                                                }}
                                                                            >

                                                                                {item.children.map(
                                                                                    (
                                                                                        child
                                                                                    ) => (
                                                                                        <tr
                                                                                            key={
                                                                                                child.admin_id ||
                                                                                                child.uid
                                                                                            }
                                                                                        >

                                                                                            {/* CHILD UID */}
                                                                                            <td className="text-start">

                                                                                                <a
                                                                                                    href="#"
                                                                                                    className="text-primary"
                                                                                                    onClick={(
                                                                                                        e
                                                                                                    ) =>
                                                                                                        e.preventDefault()
                                                                                                    }
                                                                                                >
                                                                                                    <span>
                                                                                                        CL
                                                                                                    </span>
                                                                                                </a>

                                                                                                {child.username ||
                                                                                                    child.name ||
                                                                                                    child.uid ||
                                                                                                    ''}
                                                                                            </td>

                                                                                            {/* CHILD UPLINE P/L */}
                                                                                            <td>
                                                                                                <span
                                                                                                    className={getColorClass(
                                                                                                        child.upline_pl
                                                                                                    )}
                                                                                                >
                                                                                                    {formatNumber(
                                                                                                        child.upline_pl
                                                                                                    )}
                                                                                                </span>
                                                                                            </td>

                                                                                        </tr>
                                                                                    )
                                                                                )}

                                                                            </tbody>

                                                                        </table>

                                                                    </td>

                                                                </tr>
                                                            )}

                                                    </React.Fragment>
                                                );
                                            }
                                        )}

                                        {/* TOTAL */}
                                        {totals && (
                                            <tr className="total-table-balance-none">

                                                <td>
                                                    <strong>
                                                        Total
                                                    </strong>
                                                </td>

                                                <td>
                                                    <strong>
                                                        <span
                                                            className={getColorClass(
                                                                totals.upline_pl
                                                            )}
                                                        >
                                                            {formatNumber(
                                                                totals.upline_pl
                                                            )}
                                                        </span>
                                                    </strong>
                                                </td>

                                            </tr>
                                        )}
                                    </>
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="2"
                                            className="text-center py-4"
                                        >
                                            No data available
                                        </td>
                                    </tr>
                                )}

                            </tbody>

                        </table>

                        {renderPagination()}

                    </>
                )}

            </div>
        </div>
    );

    // =========================================================
    // CASINO GAME TABLE
    // ONLY UID + UPLINE P/L
    // =========================================================
    const renderCasinoGameTable = () => (
        <div className="account-table">

            <div className="responsive">

                {loading ? (
                    <div className="text-center py-4">
                        Loading...
                    </div>
                ) : error ? (
                    <div className="alert alert-danger">
                        {error}
                    </div>
                ) : (
                    <>
                        <table className="table">

                            <thead>
                                <tr>
                                    <th scope="col">
                                        UID
                                    </th>

                                    <th scope="col">
                                        Upline P/L
                                    </th>
                                </tr>
                            </thead>

                            <tbody>

                                {reportData &&
                                reportData.length > 0 ? (
                                    <>
                                        {reportData.map(
                                            (item) => (
                                                <tr
                                                    key={
                                                        item.uid ||
                                                        item.id
                                                    }
                                                >

                                                    <td className="text-start">
                                                        {item.name ||
                                                            item.uid ||
                                                            ''}
                                                    </td>

                                                    <td>
                                                        <span
                                                            className={getColorClass(
                                                                item.upline_pl
                                                            )}
                                                        >
                                                            {formatNumber(
                                                                item.upline_pl
                                                            )}
                                                        </span>
                                                    </td>

                                                </tr>
                                            )
                                        )}

                                        {/* TOTAL */}
                                        {totals && (
                                            <tr className="total-table-balance-none">

                                                <td>
                                                    <strong>
                                                        Total
                                                    </strong>
                                                </td>

                                                <td>
                                                    <strong>
                                                        <span
                                                            className={getColorClass(
                                                                totals.upline_pl
                                                            )}
                                                        >
                                                            {formatNumber(
                                                                totals.upline_pl
                                                            )}
                                                        </span>
                                                    </strong>
                                                </td>

                                            </tr>
                                        )}
                                    </>
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="2"
                                            className="text-center py-4"
                                        >
                                            No data available
                                        </td>
                                    </tr>
                                )}

                            </tbody>

                        </table>

                        {renderPagination()}

                    </>
                )}

            </div>
        </div>
    );

    // =========================================================
    // PLAYER TABLE
    // ONLY UID + UPLINE P/L
    // =========================================================
    const renderPlayerTable = () => (
        <div className="account-table">

            <div className="responsive">

                {loading ? (
                    <div className="text-center py-4">
                        Loading...
                    </div>
                ) : error ? (
                    <div className="alert alert-danger">
                        {error}
                    </div>
                ) : (
                    <>
                        <table className="table">

                            <thead>
                                <tr>
                                    <th scope="col">
                                        UID
                                    </th>

                                    <th scope="col">
                                        Upline P/L
                                    </th>
                                </tr>
                            </thead>

                            <tbody>

                                {reportData &&
                                reportData.length > 0 ? (
                                    <>
                                        {reportData.map(
                                            (item) => (
                                                <tr
                                                    key={
                                                        item.uid ||
                                                        item.id
                                                    }
                                                >

                                                    <td className="text-start">

                                                        <a
                                                            href="#"
                                                            className="text-primary-span"
                                                            onClick={(
                                                                e
                                                            ) =>
                                                                e.preventDefault()
                                                            }
                                                        >
                                                            <span>
                                                                CL
                                                            </span>
                                                        </a>

                                                        {item.name ||
                                                            item.uid ||
                                                            ''}

                                                    </td>

                                                    <td>
                                                        <span
                                                            className={getColorClass(
                                                                item.upline_pl
                                                            )}
                                                        >
                                                            {formatNumber(
                                                                item.upline_pl
                                                            )}
                                                        </span>
                                                    </td>

                                                </tr>
                                            )
                                        )}

                                        {/* TOTAL */}
                                        {totals && (
                                            <tr className="total-table-balance-none">

                                                <td>
                                                    <strong>
                                                        Total
                                                    </strong>
                                                </td>

                                                <td>
                                                    <strong>
                                                        <span
                                                            className={getColorClass(
                                                                totals.upline_pl
                                                            )}
                                                        >
                                                            {formatNumber(
                                                                totals.upline_pl
                                                            )}
                                                        </span>
                                                    </strong>
                                                </td>

                                            </tr>
                                        )}
                                    </>
                                ) : (
                                    <tr>
                                        <td
                                            colSpan="2"
                                            className="text-center py-4"
                                        >
                                            No data available
                                        </td>
                                    </tr>
                                )}

                            </tbody>

                        </table>

                        {renderPagination()}

                    </>
                )}

            </div>
        </div>
    );

    // =========================================================
    // PAGINATION
    // =========================================================
    const renderPagination = () => {

        if (pagination.total_pages <= 0) {
            return null;
        }

        const pages = [
            pagination.current_page - 1,
            pagination.current_page,
            pagination.current_page + 1
        ].filter(
            (p) =>
                p > 0 &&
                p <= pagination.total_pages
        );

        return (
            <div className="bottom-pagination d-flex justify-content-center align-items-center">

                <ul className="pagination mb-0 gap-0">

                    {/* PREVIOUS */}
                    <li
                        className={`previous ${
                            pagination.current_page === 1
                                ? "disabled"
                                : ""
                        }`}
                    >
                        <Link
                            to="#"
                            onClick={(e) => {
                                e.preventDefault();

                                if (
                                    pagination.current_page >
                                    1
                                ) {
                                    handlePageChange(
                                        pagination.current_page -
                                        1
                                    );
                                }
                            }}
                        >
                            <FaChevronLeft />
                        </Link>
                    </li>

                    {/* PAGE NUMBERS */}
                    {pages.map((page) => (
                        <li
                            key={page}
                            className={`p-0 ${
                                pagination.current_page === page
                                    ? "active"
                                    : ""
                            }`}
                        >
                            <Link
                                to="#"
                                className="pagintion-li"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handlePageChange(page);
                                }}
                            >
                                {page}
                            </Link>
                        </li>
                    ))}

                    {/* NEXT */}
                    <li
                        className={`next ${
                            pagination.current_page ===
                            pagination.total_pages
                                ? "disabled"
                                : ""
                        }`}
                    >
                        <Link
                            to="#"
                            onClick={(e) => {
                                e.preventDefault();

                                if (
                                    pagination.current_page <
                                    pagination.total_pages
                                ) {
                                    handlePageChange(
                                        pagination.current_page +
                                        1
                                    );
                                }
                            }}
                        >
                            <FaChevronRight />
                        </Link>
                    </li>

                </ul>

            </div>
        );
    };

    // =========================================================
    // MAIN
    // =========================================================
    return (
        <main className="allcommon">

            <section className="py-4 main-inner-outer">

                <div className="container-fluid">

                    <div className="db-sec">
                        <h2 className="common-heading">
                            Profit Loss International
                        </h2>
                    </div>

                    <div className="inner-wrapper">

                        <div className="common-tab">

                            {/* TABS */}
                            <ul
                                className="nav nav-tabs"
                                role="tablist"
                            >

                                <li
                                    className="nav-item"
                                    role="presentation"
                                >
                                    <button
                                        type="button"
                                        role="tab"
                                        aria-selected={
                                            activeTab ===
                                            'Casino'
                                        }
                                        className={`nav-link ${
                                            activeTab ===
                                            'Casino'
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={() =>
                                            handleTabChange(
                                                'Casino'
                                            )
                                        }
                                    >
                                        Casino
                                    </button>
                                </li>

                                <li
                                    className="nav-item"
                                    role="presentation"
                                >
                                    <button
                                        type="button"
                                        role="tab"
                                        aria-selected={
                                            activeTab ===
                                            'CasinoGamePnL'
                                        }
                                        className={`nav-link ${
                                            activeTab ===
                                            'CasinoGamePnL'
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={() =>
                                            handleTabChange(
                                                'CasinoGamePnL'
                                            )
                                        }
                                    >
                                        CasinoGamePnL
                                    </button>
                                </li>

                                <li
                                    className="nav-item"
                                    role="presentation"
                                >
                                    <button
                                        type="button"
                                        role="tab"
                                        aria-selected={
                                            activeTab ===
                                            'PlayerPnL'
                                        }
                                        className={`nav-link ${
                                            activeTab ===
                                            'PlayerPnL'
                                                ? 'active'
                                                : ''
                                        }`}
                                        onClick={() =>
                                            handleTabChange(
                                                'PlayerPnL'
                                            )
                                        }
                                    >
                                        PlayerPnL
                                    </button>
                                </li>

                            </ul>

                            {/* TAB CONTENT */}
                            <div className="tab-content">

                                {/* =========================
                                    CASINO
                                ========================= */}
                                <div
                                    role="tabpanel"
                                    className={`fade tab-pane ${
                                        activeTab ===
                                        'Casino'
                                            ? 'active show'
                                            : ''
                                    }`}
                                >
                                    <div className="common-container">

                                        {renderFilterForm()}

                                        {renderCasinoTable()}

                                    </div>
                                </div>

                                {/* =========================
                                    CASINO GAME PNL
                                ========================= */}
                                <div
                                    role="tabpanel"
                                    className={`fade tab-pane ${
                                        activeTab ===
                                        'CasinoGamePnL'
                                            ? 'active show'
                                            : ''
                                    }`}
                                >
                                    <div className="common-container">

                                        {renderFilterForm()}

                                        {renderCasinoGameTable()}

                                    </div>
                                </div>

                                {/* =========================
                                    PLAYER PNL
                                ========================= */}
                                <div
                                    role="tabpanel"
                                    className={`fade tab-pane ${
                                        activeTab ===
                                        'PlayerPnL'
                                            ? 'active show'
                                            : ''
                                    }`}
                                >
                                    <div className="common-container">

                                        {renderFilterForm()}

                                        {renderPlayerTable()}

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

        </main>
    );
}

export default Profitlossaura;